import { Component, OnInit } from '@angular/core';
import { fadeAnimation } from '@app/animations';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.css'],
  animations: [fadeAnimation]
})
export class ContentLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }
}
